import React, { useEffect, useContext, useState } from "react";

import { doSignOut } from "../../services/firebase/auth";

function Logout() {

    useEffect(() => {
        doSignOut();
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', paddingLeft: 60, height: '100vh', textAlign: 'center' }}></div>
    )
}

export default Logout;